const unq = [
  "add-swatch-chiffon-in-pale-blush",
  "add-swatch-chiffon-in-dusty-blue",
  "add-swatch-chiffon-in-mauve-floret",
  "add-swatch-chiffon-in-dove-gray",
  "add-swatch-crepe-in-dusty-blue",
];

var errors = document.querySelector("#customer_login .errors ul"),
  ulToDiv = errors?.innerHTML,
  errorItem,
  liToSpan;
if (errors) {
  errors.outerHTML = `<div role="alert">${ulToDiv}</div>`;
  errorItem = document.querySelector("#customer_login .errors div li");
  liToSpan = errorItem?.innerHTML;
  errorItem.outerHTML = `<span>${liToSpan}</span>`;
}
document.querySelectorAll(".carousel-left").forEach((el) => {
  el.setAttribute("tabindex", "0");
  el.setAttribute("role", "button");
  el.setAttribute("aria-label", "Previous");
  el.setAttribute("aria-hidden", "false");
});
document.querySelectorAll(".carousel-right").forEach((el) => {
  el.setAttribute("tabindex", "0");
  el.setAttribute("role", "button");
  el.setAttribute("aria-label", "Next");
  el.setAttribute("aria-hidden", "false");
});
document
  .querySelectorAll(".filter-picker-container label .std-checkbox")
  .forEach((el) => {
    el.addEventListener("click", function () {
      if (el.getAttribute("aria-checked") === "false") {
        el.setAttribute("aria-checked", "true");
      } else {
        el.setAttribute("aria-checked", "false");
      }
    });
  });

//Blog
document.querySelectorAll(".bg-blog-post .blog-product").forEach((el) => {
  var blogproductTitle = el
    .querySelector("a.blog-product-img-link")
    .getAttribute("href");
  var titleVal = blogproductTitle.split("/");
  var titleValRevese = titleVal.reverse();
  var linkTitle = titleValRevese[0].replace(/\-/g, " ");
  el.querySelector("a.blog-product-img-link").setAttribute(
    "aria-label",
    linkTitle,
  );
});
document
  .querySelectorAll(".blog-product-img-link img.blog-product-image")
  .forEach((el) => {
    el.removeAttribute("alt");
  });
document.querySelectorAll(".bg-blog-post .blog-product").forEach((el) => {
  var blogTitleVal = el.querySelector(
    ".blog-product-content .blog-product-title",
  )?.innerHTML;
  var blogSubTitleVal = el
    .querySelector(".blog-product-content .blog-product-subhead")
    ?.innerHTML.toLowerCase();
  el.querySelector(".blog-product-content a").setAttribute(
    "aria-label",
    "Shop this product: " + blogTitleVal + " " + blogSubTitleVal,
  );
});

//fabric-101 Page
document.querySelectorAll(".fabric-section__sub-text a").forEach((el) => {
  if (el.innerHTML.trim() === "") {
    el.remove();
  }
});

//How To Work Page
document.querySelectorAll(".cwi-badge svg").forEach((el) => {
  el.removeAttribute("id");
});

// swatch-color-palettes
document.querySelectorAll(".swatch-color-palettes .lh105").forEach((el) => {
  el.setAttribute("role", "heading");
  el.setAttribute("aria-level", "1");
});

// sweepstakes
document.querySelectorAll(".sweepstakes h2.knot__header").forEach((el) => {
  el.setAttribute("role", "heading");
  el.setAttribute("aria-level", "1");
});

//mix-match-bridesmaid-dresses
document
  .querySelectorAll(".mix-match-bridesmaid-dresses .top5.bottom5 a")
  .forEach((el) => {
    if (el.parentElement.querySelector(".heading")) {
      el.setAttribute(
        "aria-label",
        el.innerHTML.trim() +
          " - " +
          el.parentElement.querySelector(".heading").innerHTML.trim(),
      );
    }
  });
document
  .querySelectorAll(".mix-match-bridesmaid-dresses .top5.bottom5 .heading")
  .forEach((el) => {
    el.setAttribute("role", "heading");
    el.setAttribute("aria-level", "2");
  });

document.querySelectorAll(".keyboard-only-fix").forEach((el) => {
  el.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      el.click();
    }
  });
});
document
  .querySelectorAll(".tab-container > div[aria-expanded]")
  .forEach((el) => {
    el.addEventListener("click", () => {
      el.setAttribute(
        "aria-expanded",
        `${el.getAttribute("aria-expanded") === "false"}`,
      );
    });
  });

document
  .querySelectorAll(".kiko-dress-mauve #see-it-in-the-wild-carousel")
  .forEach((el) => {
    el.setAttribute("tabindex", "0");
  });

document.querySelectorAll(".blog-multi-product-product a").forEach((el) => {
  if (el.innerHTML.trim() === "") {
    el.remove();
  }
});

waitForElm('[aria-labelledby="downshift-0-label"]').then(function () {
  document
    .querySelectorAll('[aria-labelledby="downshift-0-label"]')
    .forEach(function (item) {
      item.removeAttribute("aria-labelledby");
    });
});

document
  .querySelectorAll('iframe[src^="https://player.vimeo.com/video/236874230"]')
  .forEach((el) => {
    el.setAttribute("title", "HOW TO MEASURE FOR A BRIDESMAID DRESS");
  });

unq.forEach(function (elem) {
  let count = 0,
    element = document.getElementById(elem);
  element?.setAttribute("id", element.getAttribute("id") + "__" + count++);
});

document
  .querySelectorAll('.top5.bottom5 [href="/collections/spring-bouquet"]')
  .forEach(function (el) {
    if (el.parentElement.querySelector(".heading")) {
      el.setAttribute(
        "aria-label",
        el.innerHTML.trim() +
          " - " +
          el.parentElement.querySelector(".heading").innerHTML.trim(),
      );
    }
  });

document
  .querySelectorAll(".mix-match-bridesmaid-dresses h2.lh105")
  .forEach((el) => {
    el.setAttribute("role", "heading");
    el.setAttribute("aria-level", "1");
  });

let i = 0;
document
  .querySelectorAll(".mix-match-bridesmaid-dresses  button.quick-atc")
  .forEach(function (item) {
    item.setAttribute("id", item.getAttribute("id") + i++);
  });

setTimeout(function () {
  document
    .querySelectorAll("#upsell-carousel .carousel-item")
    .forEach(function (el) {
      el.setAttribute("role", "listitem");
    });
}, 2500);

document
  .querySelectorAll("form.needsclick.klaviyo-form span.ql-font-abril-display")
  .forEach((el) => {
    el.setAttribute("role", "heading");
    el.setAttribute("aria-level", "1");
  });
document
  .querySelectorAll("form.needsclick.klaviyo-form div#downshift-0-menu")
  .forEach((el) => {
    el.setAttribute("role", "group");
    el.setAttribute("aria-label", "Wedding Role List");
  });
document
  .querySelectorAll(
    "form.needsclick.klaviyo-form button#downshift-0-toggle-button",
  )
  .forEach((el) => {
    el.setAttribute("aria-label", "Wedding Role Option");
  });
document
  .querySelectorAll(
    "form.needsclick.klaviyo-form button.kl-private-reset-css-Xuajs1:not(#downshift-0-toggle-button)",
  )
  .forEach((el) => {
    el.style.color = "#000000";
  });

function waitForElm(e) {
  return new Promise((r) => {
    if (document.querySelector(e)) return r(document.querySelector(e));
    let t = new MutationObserver((o) => {
      document.querySelector(e) &&
        (r(document.querySelector(e)), t.disconnect());
    });
    t.observe(document.body, { childList: !0, subtree: !0 });
  });
}
